export default __webpack_public_path__ + "static/testimonial_3-b0efdcdf2c6d85bac28cf6139de2d9a5.png";